import React, { useState, useEffect } from "react";
import api from "src/lib/api";
import { useUser } from "src/hooks/useUser";
import { trackEvent } from "src/lib/analytics";
import { useRef } from "react";

export type RequestEarlyAccessFormProps = {
  autoFocus?: boolean;
  buttonText?: string;
  interest?: "ENGINE" | "FLOW" | "ANALYTICS" | "CLOUD";
  maintenance?: boolean;
  signup: (mailchimpUser: any) => void;
};

const RequestEarlyAccessForm: React.FC<RequestEarlyAccessFormProps> = ({
  autoFocus,
  buttonText,
  interest,
  maintenance,
  signup,
}) => {
  const [email, setEmail] = useState<string>("");
  const [disableForm, setDisableForm] = useState(false);
  const [signupStatus, setSignupStatus] = useState("");

  const inputRef = useRef<HTMLInputElement | null>(null);
  useEffect(() => {
    if (autoFocus && window.screen.width > 767) {
      inputRef.current?.focus();
    }
  }, []);

  const [user] = useUser();

  const onSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const merge_fields: any = {
      REFERRER: localStorage.getItem("referrer") || window.document.referrer,
      SIGNUPLOC: window.location.href,
    };
    if (interest) {
      merge_fields[interest] = "Yes";
      trackEvent(
        {
          category: "Growth",
          action: `Interest: ${interest}`,
        },
        user
      );
    }
    setDisableForm(true);
    const { data } = await api.post(
      "/subscribe/email",
      {},
      {
        email: user ? user.email : email,
        merge_fields,
        maintenance,
      }
    );
    if (data.response.status === "subscribed") {
      trackEvent(
        {
          category: "Growth",
          action: "Email Signup",
        },
        user
      );
      if (maintenance) {
        return setSignupStatus(
          "Thank you. We'll get back to you as soon as we can."
        );
      }
      signup(data.response);
    } else if (!data?.response?.title) {
      setSignupStatus("Something went wrong ☹️ Please try again later");
    } else if (data.response.title.includes("Invalid Resource")) {
      setSignupStatus("Are you sure? 🤔 Please try a different address…");
    } else if (data.response.title.includes("Member Exists")) {
      if (maintenance) {
        return setSignupStatus(
          "We're working on the site right now - please check back in an hour or two."
        );
      }
      if (data.response.merge_fields.ACTIVATED !== "Yes") {
        signup(data.response);
      } else if (interest) {
        await api.patch(
          "/subscribe/email",
          {},
          {
            mailchimp_id: data.response.id,
            merge_fields: {
              [interest]: "Yes",
            },
          }
        );
        return setSignupStatus("Thank you, we've registered your interest.");
      } else if (email === user?.email) {
        setSignupStatus("You're already logged in to this account.");
      } else {
        setSignupStatus("You've already got an account. Please sign in!");
      }
    }
    setTimeout(() => {
      setSignupStatus("");
      setEmail("");
      setDisableForm(false);
    }, 2000);
  };

  return (
    <form className="early-access" onSubmit={onSubmit}>
      <div className="signup-status">{signupStatus}</div>
      <div>
        <div className="input-wrapper">
          <input
            type="email"
            name="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Enter your email"
            className={"input"}
            disabled={disableForm}
            ref={inputRef}
            required
          />
        </div>
        <button type="submit" className={"primary-button"}>
          {buttonText
            ? buttonText
            : interest
            ? "Create My Account"
            : "Get Started"}
        </button>
      </div>
    </form>
  );
};

export default RequestEarlyAccessForm;
